import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class LeadsAnalyticService {

    constructor() {

        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.LEADS_ANALYTIC = '/api/leads-analytic';
        this.GET_BY_PROJECT_ID = '/{projectId}';
        this.GET_CHART_DATA_BY_PROJECT_ID_AND_TIME_STAMP = '/{projectId}/create-time-stamp/{createTimeStamp}';
    }

    async getAnalyticByProjectId(projectId) {
		let url = window.location.origin + this.LEADS_ANALYTIC + this.GET_BY_PROJECT_ID;
		url = url
			.replace('{projectId}', projectId);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}

    async getAnalyticByCharts(projectId, createTimeStamp) {
		let url = window.location.origin + this.LEADS_ANALYTIC + this.GET_CHART_DATA_BY_PROJECT_ID_AND_TIME_STAMP;
		url = url
			.replace('{projectId}', projectId)
			.replace('{createTimeStamp}', createTimeStamp);
		try {
			return this.fetch(url, {
				method: 'GET',
				retries: 10,
				retryDelay: 200
			}).then(data => data.json())
				.then(data => {
					if (data.error !== undefined) {
						if (data.error === 'Session Expired') {
							let userAuthService = new UserAuthService();
							userAuthService.logout();
						}
						else {
							localStorage.setItem('errorUUID', data.uuid);
						}
					}
					return data;
				})
		} catch (err) {
			console.log(err)
		}
	}
}

export default LeadsAnalyticService;